(function () {
	'use strict';
	angular.module('app.core')
		.service('supplierLateDeliveryIssueRenderService', supplierLateDeliveryIssueRenderService);

	supplierLateDeliveryIssueRenderService.$inject = [];

	function supplierLateDeliveryIssueRenderService() {
		var service = {
			descriptionRenderer: descriptionRenderer,
			liabilityRenderer: liabilityRenderer,
			deliveryStatusRenderer: deliveryStatusRenderer
		};

		return service;

		function descriptionRenderer(row, col, rowIndex, params) {
			var extraClass = '';
			var archiveActionClass = 'fa-archive';
			var archiveAction = 'archive';
			var message = 'Click to {0} supplier delivery cause';
			var actionElement = '<i class="fa fa-pencil" title="{{\'' + String.format(message, 'edit') +'\' | translate}}" ng-click="' +
				'vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'Edit Cause\', \'text\', 100)"></i>';

			if (row.stateType === 'Archived') {
				archiveActionClass = 'fa-check';
				archiveAction = 'enable';
				extraClass = 'archive';
			}

			actionElement += '<i class="fa ' + archiveActionClass + '" '
				+ 'title="{{\'' + String.format(message, archiveAction) +'\' | translate}}" ng-click="vm.archiveLateDeliveryIssue(' + row.ndx + ', ' + row.lastModified + ', \'' + row.stateType + '\')"></i>';

			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text with-delete ' + extraClass + '">' + row.description +
				'</div>' +
				'<div class="inlineActionIcons with-delete">' + actionElement + '</div>' +
				'</div>';
		}

		function liabilityRenderer(row, col, rowIndex, params) {
			var extraClass = '';
			var content = row.liability;
			var actionElement = '<i class="fa fa-pencil" title="{{\'Click to edit liability\' | translate}}" ng-click="' +
				'vm.startEditList(' + rowIndex + ',\'' + col.id + '\', \'' + row.liability + '\')" translate></i>';
			if (content === 'Customer') {
				content = globalConfig.customer.name;
			}
			if (row.stateType === 'Archived') {
				extraClass = 'archive';
			}
			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text with-delete ' + extraClass + '" translate>' + content +
				'</div>' +
				'<div class="inlineActionIcons with-delete">' + actionElement + '</div>' +
				'</div>';
		}

		function deliveryStatusRenderer(row, col, rowIndex, params) {
			var extraClass = '';
			var content = row.deliveryStatus;
			var actionElement = '<i class="fa fa-pencil" title="{{\'Click to edit delivery status\' | translate}}" ng-click="' +
				'vm.startEditList(' + rowIndex + ',\'' + col.id + '\', \'' + row.deliveryStatus + '\')"></i>';
			if (content === 'Customer') {
				content = globalConfig.customer.name;
			}
			if (row.stateType === 'Archived') {
				extraClass = 'archive';
			}
			return '<div class="cell-div inline-edit-cell">' +
				'<div class="edit-name-text with-delete ' + extraClass + '" translate>' + content +
				'</div>' +
				'<div class="inlineActionIcons with-delete">' + actionElement + '</div>' +
				'</div>';
		}
	}
})();
